import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-familia-light py-12 md:py-16 px-4 md:px-6" data-id="element-63" data-mp="1bmlnvb30w3m2">
      <div className="max-w-3xl mx-auto w-full" data-id="element-64" data-mp="1gk57yrmejalx">
        <h2 className="text-[26px] sm:text-3xl md:text-4xl font-display font-bold text-familia-ink text-center mb-8 md:mb-12" data-id="element-65" data-mp="249g05kporwog">
          Preguntas frecuentes
        </h2>
        <div className="space-y-3" data-id="element-66" data-mp="28cm76ukmhrvz">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          const panelId = `faq-panel-${i}`;
          return <div key={faq.q} className={`border rounded-xl overflow-hidden bg-familia-lightCard transition-colors duration-200 ease-out ${isOpen ? 'border-familia-accent' : 'border-familia-lightBorder'}`} data-id="element-67" data-mp="1zh6fok7cbotk" data-mpi={i}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="w-full px-5 md:px-6 py-4 md:py-5 text-left flex justify-between items-center gap-4" data-id="element-68" data-mp="2s0bqedehujtl">
                  <span className="font-bold text-[17px] md:text-[18px] text-familia-ink leading-snug" data-id="element-69" data-mp="10rvt2zdbm2l8">
                    {faq.q}
                  </span>
                  <PlusIcon className={`w-6 h-6 text-familia-accent shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-70" data-mp="19tlki577d1j0" />
                </button>
                <AnimatePresence initial={false} data-id="element-71" data-mp="1jjetqzjvh4k3">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-72" data-mp="1xjple4t0an6b">
                      <div className="px-5 md:px-6 pb-5 pt-3 text-body text-familia-inkMuted border-t border-familia-lightBorder" data-id="element-73" data-mp="1y9czfh0frz4y">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};